import axios, { InternalAxiosRequestConfig } from 'axios'
import { getTeleAuth } from './teleConsultaAuth'

export const axiosTeleConsulta = axios.create({
  headers: { Accept: 'application/json' },
})

axiosTeleConsulta.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const auth = getTeleAuth()
  if (auth?.accessToken) {
    config.headers.Authorization = `Bearer ${auth.accessToken}`
  }

  return config
})
